import './consoleSilence';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/spacing-tokens.css';
import './index.css';
import './styles/global-buttons.css';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/responsive-laptop-14.css';
import './styles/section-headings-unified.css';
import './styles/site-background.css';
import './styles/theme-component-vars.css';
import './styles/focus-visible.css';
import './styles/home-card-image-hover.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// Load Bootstrap JS after app is interactive so it doesn't block initial parse
if (typeof requestIdleCallback !== 'undefined') {
  requestIdleCallback(() => import('bootstrap/dist/js/bootstrap.bundle.min.js'), { timeout: 500 });
} else {
  setTimeout(() => import('bootstrap/dist/js/bootstrap.bundle.min.js'), 1);
}

// Defer web vitals so it doesn't block first paint
setTimeout(() => {
  import('./reportWebVitals').then((m) => m.default());
}, 0);
